import { useEffect, useState } from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

export const usePublicSession = (userId, computerId) => {
  const [publicSession, setPublicSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userId || !computerId) return;

    const docRef = firebase
      .firestore()
      .collection("customers")
      .doc(userId)
      .collection("public_computers")
      .doc(computerId);

    const unsubscribe = docRef.onSnapshot(
      (docSnapshot) => {
        if (docSnapshot.exists) {
          const data = docSnapshot.data();
          setPublicSession(data?.public_session ?? null);
        } else {
          console.warn("Document not found");
          setPublicSession(null);
        }
        setLoading(false);
      },
      (err) => {
        console.error("Erreur lors de l'écoute du document :", err);
        setError(err.message);
        setLoading(false);
      }
    );

    // cleanup
    return () => unsubscribe();
  }, [userId, computerId]);

  return { publicSession, loading, error };
};
